import useTypewriterOnView from "../../hooks/useTypewriterOnView";

// Section heading that types itself out on first view (caret while typing).
// `text` may contain "\n"; pair with white-space: pre-line in CSS.
const TypedHeading = ({ text, className = "", id }) => {
  const { ref, shown, typing } = useTypewriterOnView(text);

  return (
    <h2 ref={ref} id={id} className={`typed-heading ${className}`.trim()}>
      {shown}
      {typing && <span className="typed-heading__caret" aria-hidden="true">_</span>}
    </h2>
  );
};

export default TypedHeading;
